import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  CardFooter,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import ChangeRoleModal from './ChangeRoleModal';
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound';
import { slimColourStyles, PAGE_SIZES } from '../../components/Styles/Filter';
import history from '../../history';
import { verifyAccessToken } from '../../lib/auth';
import axios from '../../lib/axiosInstance';

import { MagicSpinner } from 'react-spinners-kit';
import TextField from '@mui/material/TextField';
import '@y0c/react-datepicker/assets/styles/calendar.scss';
import moment from 'moment';
import TableWithStickyHeader from 'components/TableWithStickyHeader';

// import calendar style
const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
// const SeverityList = {
//     "5": "Critical",
//     "4": "Urgent",
//     "3": "Serious",
//     "2": "Medium",
//     "1": "Minimal"
// }

class Members extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      currentReport: {},
      members: [],
      currentData: {},
      tagData: [],
      searchValue: '',
      currentTag: {},
      selectedTags: [],
      company_search_data: '',
      openModal: false,
      loader: true,
      createModal: false,
      currentPage: 0,
      pageSize: 25.0,
      ordering: '',
      modalDeleteMember: false,
      modalUnassignMember: false,
      id: '',
      assignee: '',
      selectedAssignOption: 'unassign',
      index: '',
      isDeleting: false,
      modalRoleChange: false,
      targetRole: '',
      currentRole: '',
    };
  }
  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchListingData();
    }, 60);
  }

  handleAssigneeChange(value) {
    this.setState({ assignee: value.users_id });
  }
  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  componentDidMount() {
    let search = window.location.search.split('search=');
    if (search.length > 1) {
      search = window.location.search.split('search=')[1].split('&')[0];
      this.setState({ company_search_data: search });
    }
    localStorage.setItem('last_path', window.location.pathname);
    this.updatePage();
  }
  componentDidUpdate(prevProps, prevState) {
    // Check if the specific prop has been updated
    if (this.props.currentCompanyId !== prevProps.currentCompanyId) {
      this.updatePage();
    }
  }

  updatePage() {
    this.fetchProfiles.bind(this)();
    this.fetchListingData();
  }

  async fetchProfiles() {
    this.setState({ loader: true });
    await verifyAccessToken();
    let currentCompanyId = this.props.currentCompanyId;
    let url = '/profiles/colleague/?search=' + '&limit=250',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    url += '&ordering=name';
    url += '&company=' + currentCompanyId;
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              members: res.data.results,
            });
            document.getElementsByClassName('main-panel')[0].scrollTop = 0;
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
      });
  }

  async fetchListingData(currentUrl, currentPage, company_id) {
    this.setState({ loader: true });
    await verifyAccessToken();
    if (company_id === undefined) {
      company_id = this.props.currentCompanyId;
    }
    let url =
        '/profiles/colleague/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize),
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (currentUrl) {
      url = currentUrl;
    }
    url += '&ordering=' + this.state.ordering;
    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }
    url += '&company=' + company_id;
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? '/profiles/colleague/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/profiles/colleague/?' + res.data.previous.split('?')[1]
                : null,
            });
            document.getElementsByClassName('main-panel')[0].scrollTop = 0;
          } else {
            this.setState({ reports: [], count: 0 });
          }

          // this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
      });
  }
  async fetchDetails(id, reauth) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/profiles/colleague/' + id + '/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            // let currentData = res.data
            this.setState({
              currentReport: res.data,
              loader: false,
              modal: true,
            });
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401) {
          if (reauth === true) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            history.push('/login');
          } else this.fetchDetails(id, true);
        } else if (res.status === 200) {
        }
      });
  }
  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() =>
              this.fetchListingData(
                this.state.nextUrl,
                this.state.currentPage + 1,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() =>
              this.fetchListingData(
                this.state.previousUrl,
                this.state.currentPage - 1,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / this.state.pageSize),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      let url =
        '/profiles/colleague/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize) +
        '&offset=' +
        parseInt(this.state.pageSize * index);
      pages.push(
        <PaginationItem
          key={index}
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchListingData(url, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        let url =
          '/profiles/colleague/?search=' +
          this.state.company_search_data +
          '&limit=' +
          parseInt(this.state.pageSize) +
          '&offset=' +
          parseInt(this.state.pageSize * pageIndex);
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink
              onClick={() => this.fetchListingData(url, pageIndex)}
            >
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(
        <PaginationItem className="more-pages">
          {/* <PaginationLink > */}
          ...
          {/* </PaginationLink> */}
        </PaginationItem>,
      );
    }
    if (rightPages >= 1) {
      let url =
        '/profiles/colleague/?search=' +
        this.state.company_search_data +
        '&limit=' +
        parseInt(this.state.pageSize) +
        '&offset=' +
        parseInt(this.state.pageSize * (pageCount - 1));
      pages.push(
        <PaginationItem
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink
            onClick={() => this.fetchListingData(url, pageCount - 1)}
          >
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / this.state.pageSize);
    if (pageCount > 1) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10">
            <Pagination aria-label="Page navigation example">
              {this.renderPreviousUrl()}
              {this.renderPages()}
              {this.renderNextUrl()}
            </Pagination>
          </Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchListingData();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    } else if (this.state.count > 25) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10"></Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchListingData();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    }
  }
  async deleteMember(action) {
    let company = this.props.currentCompanyId;
    let loggedInUser = localStorage.getItem('loggedInUser');
    await verifyAccessToken();
    let url =
        '/companies/remove-member/' +
        company +
        '?id=' +
        this.state.id +
        '&loggedInUser=' +
        loggedInUser,
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (action === 'unassign') {
      url = url + '&assignee=None';
    } else if (action === 'reassign') {
      if (this.state.assignee !== '') {
        url = url + '&assignee=' + this.state.assignee;
      } else {
        toast.error('Please select an assignee!', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
    }
    this.setState({ isDeleting: true });
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          let index = this.state.index;
          let data = this.state.reports;
          data.splice(index, 1);
          toast.info('Success! ' + res.data.message, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.setState({ reports: data, isDeleting: false });
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          if (
            err.response.data.message ===
            'Cannot delete member because they have vulnerabilities assigned.'
          ) {
            this.setState({
              modalUnassignMember: true,
            });
          } else {
            toast.error('Failed! ' + err.response.data.message, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        } else if (err.response.status === 401 || err.response.status === 400) {
          toast.error('Failed! ' + err.response.data.message, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Failed! ' + err, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .finally(() => this.setState({ isDeleting: false }));
  }

  toggleModalDelete = () => {
    this.setState({
      modalDeleteMember: !this.state.modalDeleteMember,
    });
  };

  toggleModalUnassign = () => {
    this.setState({
      modalUnassignMember: !this.state.modalUnassignMember,
    });
  };

  changeAssignee(e) {
    switch (e.target.value) {
      case 'reassign':
        this.setState({
          selectedAssignOption: 'reassign',
        });
        break;
      default:
        this.setState({
          selectedAssignOption: 'unassign',
        });
        break;
    }
  }

  renderUnassign() {
    function get_members(member) {
      return (
        member.confirmed_at != null &&
        member.confirmed_at != '' &&
        member.users_id !== this.state.id
      );
    }
    let mymembers = this.state.members.filter(get_members.bind(this));
    return (
      <>
        <Modal
          isOpen={this.state.modalUnassignMember}
          toggle={this.toggleModalUnassign}
          size="md"
        >
          <ModalHeader>
            Can't delete members with assigned vulnerabilities.
          </ModalHeader>
          <ModalBody>
            Please unassign vulnerabilities or assign to another member
            <br />
            <div onChange={this.changeAssignee.bind(this)}>
              {this.state.selectedAssignOption === 'unassign' ? (
                <input
                  type="radio"
                  value="unassign"
                  name="unassign_vuln"
                  checked
                />
              ) : (
                <input type="radio" value="unassign" name="unassign_vuln" />
              )}{' '}
              <label>Unassign vulnerabilities and delete member</label>
              <br />
              {this.state.selectedAssignOption === 'reassign' ? (
                <input
                  type="radio"
                  value="reassign"
                  name="unassign_vuln"
                  checked
                />
              ) : (
                <input type="radio" value="reassign" name="unassign_vuln" />
              )}{' '}
              <label>Reassign vulnerabilities and delete member</label>
              <br />
            </div>
            {this.state.selectedAssignOption === 'reassign' ? (
              <Select
                className="custom-360-dropdown"
                onChange={this.handleAssigneeChange.bind(this)}
                options={mymembers}
              />
            ) : (
              <></>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              size="sm"
              disabled={this.state.isDeleting}
              onClick={async () => {
                await this.deleteMember(this.state.selectedAssignOption);
                this.toggleModalUnassign();
              }}
            >
              {this.state.selectedAssignOption === 'unassign'
                ? 'Unassign and delete'
                : 'Reassign and delete'}
            </Button>
            <Button
              color="primary"
              size="sm"
              onClick={() => this.toggleModalUnassign()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
  renderButton(data, index) {
    // if(data.report_status === 'COMPLETE'){
    return (
      <>
        <Button
          color="primary"
          outline
          size="sm"
          id={'member-table-button-vuln-id-' + data.users_id}
          onClick={() => this.oepnMemeberModal.bind(this)(data)}
        >
          <i className="fa fa-paper-plane" />
        </Button>
        {atob(localStorage.getItem(btoa('approle'))) === 'admin' && (
          <Button
            color="primary"
            outline
            size="sm"
            title={'Delete member'}
            onClick={() => {
              this.setState({
                modalDeleteMember: true,
                id: data.users_id,
                index: index,
              });
            }}
          >
            <i className="fa fa-trash" />
          </Button>
        )}
        {atob(localStorage.getItem(btoa('approle'))) === 'admin' && (
          <span id={'member-table-button-role-' + data.users_id}>
            <Button
              color="primary"
              outline
              size="sm"
              title={
                data.company_role === 'ADMIN'
                  ? 'Remove Admin Role'
                  : 'Assign Admin Role'
              }
              disabled={data.email === localStorage.getItem('loggedInUser')}
              onClick={() => {
                this.setState({
                  modalRoleChange: true,
                  id: data.users_id,
                  index: index,
                  currentRole: data.company_role,
                  targetRole:
                    data.company_role === 'ADMIN' ? 'MEMBER' : 'ADMIN',
                });
              }}
            >
              <i
                className={
                  data.company_role === 'ADMIN'
                    ? 'fa fa-user-slash'
                    : 'fa fa-user-shield'
                }
              />
            </Button>
          </span>
        )}
        {data.email === localStorage.getItem('loggedInUser') &&
          atob(localStorage.getItem(btoa('approle'))) === 'admin' && (
            <UncontrolledTooltip
              placement="top"
              target={'member-table-button-role-' + data.users_id}
            >
              You cannot modify your own role.
            </UncontrolledTooltip>
          )}
        <UncontrolledTooltip
          placement="top"
          target={'member-table-button-vuln-id-' + data.users_id}
        >
          Resend invite to {data.email}
        </UncontrolledTooltip>
        <Modal
          isOpen={this.state.modalDeleteMember}
          toggle={this.toggleModalDelete}
          size="sm"
        >
          <ModalHeader>Delete member</ModalHeader>
          <ModalBody>Are you sure you want to proceed?</ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              size="sm"
              onClick={() => this.toggleModalDelete()}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              size="sm"
              disabled={this.state.isDeleting}
              onClick={async () => {
                await this.deleteMember();
                this.toggleModalDelete();
              }}
            >
              Delete
            </Button>
          </ModalFooter>
        </Modal>
        {this.state.modalRoleChange && (
          <ChangeRoleModal
            isOpen={this.state.modalRoleChange}
            onClose={() => this.setState({ modalRoleChange: false })}
            currentRole={this.state.currentRole}
            targetRole={this.state.targetRole}
            memberId={this.state.id}
            companyId={this.props.currentCompanyId}
            onRoleChanged={(newRole) => {
              let index = this.state.index;
              let data = this.state.reports;
              data[index].company_role = newRole;
              this.setState({ reports: data });
            }}
          />
        )}
      </>
    );
  }
  renderReportList() {
    let reports = this.state.reports;
    return (
      <>
        {reports.map((data, idx) => {
          return (
            <tr key={idx}>
              <td>{data['name']}</td>
              <td>{data['email']}</td>
              <td>{data['company_role']}</td>
              <td>
                {data['created_at'].length > 0
                  ? moment(data['created_at']).format('lll')
                  : ''}
              </td>
              <td>
                {data['confirmed_at'] && data['confirmed_at'] !== null
                  ? 'Yes'
                  : 'No'}
              </td>
              <td className="text-right">
                {this.renderButton.bind(this)(data, idx)}
              </td>
            </tr>
          );
        })}
      </>
    );
  }

  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        {/* <Collapse in={this.state.openModal === true}>
                <Alert severity={this.state.is_success === true ? "success" : "error"} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            this.setState({ openModal: false });
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }>
                    <AlertTitle>{this.state.modalTitle}</AlertTitle>
                    {this.state.modalDetail}
                </Alert>
            </Collapse> */}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }

  severityName(type) {}
  renderDetail(parsableData) {
    let data = this.state.currentReport.detail;
    if (parsableData !== undefined) {
      data = parsableData;
    }
    let resp = [];
    if (data) {
      let keys = Object.keys(data);
      keys.forEach((element) => {
        if (
          element !== 'createdDate' &&
          element !== 'updatedDate' &&
          element !== 'owner'
        ) {
          if (['id', 'name', 'url'].indexOf(element) === -1)
            resp.push(
              <tr key={element.id}>
                <td>{element.split(/(?=[A-Z])/).join(' ')}</td>
                <td>
                  {typeof data[element] === typeof {}
                    ? this.renderDetail(data[element])
                    : data[element]}
                </td>
              </tr>,
            );
        }
      });
    }
    return <>{resp}</>;
  }
  async addMember() {
    if (
      this.state.email !== '' &&
      this.state.first_name !== '' &&
      this.state.last_name !== ''
    ) {
      this.setState({ loader: true });
      let data = {
        email: this.state.email,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        company: this.props.currentCompanyId,
      };
      await verifyAccessToken();
      let url = '/profiles/',
        headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access'),
        };
      await axios
        .post(url, data, {
          headers: headers,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            this.setState({
              loader: false,
              createModal: false,
              openNotificationModal: true,
              modalDetail:
                'Member has been successfully added to your company.',
              modalTitle: 'Success!',
              openModal: true,
              is_success: true,
            });
            toast.info(
              'Success! ' +
                'Member has been successfully added to your company.',
              {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              },
            );
            this.fetchListingData();
          } else if (res.status === 422) {
            this.setState({
              openModal: true,
              is_success: false,
              modalTitle: 'Error!',
              modalDetail: res.data.detail,
            });
            toast.error('Error! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (res.status === 401 || res.status === 400) {
            this.setState({
              openModal: true,
              is_success: false,
              modalTitle: 'Error!',
              modalDetail: res.data.detail,
            });
            toast.error('Error! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((err) => {
          this.setState({ loader: false });
          let res = err.response;
          if (res.status === 401 || res.status === 400 || res.status === 422) {
            this.setState({
              openModal: true,
              is_success: false,
              modalTitle: 'Error',
              modalDetail: res.data.detail,
            });
            toast.error('Error! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (res.status === 200) {
          }
        });
    } else {
      let message = '';
      if (
        this.state.email === '' &&
        (this.state.first_name === '' || this.state.last_name === '')
      ) {
        message = 'Please provide valid email address and name.';
      } else if (this.state.email === '') {
        message = 'Please provide valid email address.';
      } else if (this.state.first_name === '' || this.state.last_name === '') {
        message = 'Please provide valid name.';
      }
      this.setState({
        loader: false,
        openNotificationModal: true,
        modalDetail: message,
        modalTitle: 'Error!',
        openModal: true,
        is_success: false,
      });
      toast.error('Error! ' + message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
  createToggle() {
    let createModal = this.state.createModal;
    this.setState({ createModal: !createModal });
  }
  renderCreateModal() {
    return (
      <Modal
        isOpen={this.state.createModal}
        toggle={this.createToggle.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.createToggle.bind(this)}>
          Add Member
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12" sm="6">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="first_name"
                type="text"
                defaultValue={this.state.first_name}
                label="First Name"
                name="first_name"
                autoComplete="first_name"
                autoFocus
                onChange={(element) => {
                  this.setState({ first_name: element.target.value });
                }}
              />
            </Col>
            <Col xs="12" sm="6">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="last_name"
                type="text"
                defaultValue={this.state.last_name}
                label="Last Name"
                name="last_name"
                autoComplete="last_name"
                autoFocus
                onChange={(element) => {
                  this.setState({ last_name: element.target.value });
                }}
              />
            </Col>
            <Col xs="12" sm="12">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="email"
                type="email"
                defaultValue={this.state.email}
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(element) => {
                  this.setState({ email: element.target.value });
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.createToggle.bind(this)()}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            disabled={this.state.loader}
            onClick={() => this.addMember.bind(this)()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  oepnMemeberModal(data) {
    if (data) {
      this.setState({
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        createModal: true,
      });
    } else {
      this.setState({
        first_name: '',
        last_name: '',
        email: '',
        createModal: true,
      });
    }
  }
  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6" sm="12">
                      <h4>
                        Members
                        <label className="label btn">
                          {this.state.reports.length}
                        </label>
                      </h4>
                    </Col>
                    <Col md="6" sm="12" className="d-flex justify-content-end">
                      <Row>
                        <Col md="8" sm="12">
                          <Input
                            type="text"
                            list="data"
                            style={{ marginTop: '9px' }}
                            value={this.state.company_search_data}
                            placeholder="Search Member"
                            onChange={(e) => {
                              this.setState({
                                company_search_data: e.target.value,
                              });
                              this.fetchListingData();
                            }}
                          />
                        </Col>
                        <Col md="4" sm="12" style={{ padding: '2px' }}>
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm"
                            onClick={() => this.oepnMemeberModal.bind(this)()}
                          >
                            <i className="fa fa-plus"></i>
                            <span
                              style={{
                                fontSize: '10px',
                                fontWeight: 'normal',
                                paddingTop: '2px',
                              }}
                            >
                              Invite Member
                            </span>
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.count == 0 && <NoRecordFound />}
                {this.state.count != 0 && (
                  <CardBody>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          {/* <th>ID</th> */}
                          <th
                            onClick={() => {
                              this.orderBy('name');
                            }}
                          >
                            Name
                            <i
                              className={
                                this.state.ordering === 'name'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-name'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('email');
                            }}
                          >
                            Email
                            <i
                              className={
                                this.state.ordering === 'email'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-email'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('company_role');
                            }}
                          >
                            Role
                            <i
                              className={
                                this.state.ordering === 'company_role'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-company_role'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('created_at');
                            }}
                          >
                            Invited on
                            <i
                              className={
                                this.state.ordering === 'created_at'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-created_at'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('confirmed_at');
                            }}
                          >
                            Active
                            <i
                              className={
                                this.state.ordering === 'confirmed_at'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-confirmed_at'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            className="text-right"
                            style={{ minWidth: '108px' }}
                          ></th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </TableWithStickyHeader>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle.bind(this)}
          size="lg"
        >
          <ModalHeader toggle={this.toggle.bind(this)}>
            Member Detail
          </ModalHeader>
          <ModalBody>
            <Table className="tablesorter table-striped" responsive>
              <tbody>
                <tr>
                  <td>Id</td>
                  <td>{this.state.currentReport.webapp_id}</td>
                </tr>
                <tr>
                  <td>Company</td>
                  <td>{this.state.currentReport.company}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{this.state.currentReport.name}</td>
                </tr>
                <tr>
                  <td>Url</td>
                  <td>{this.state.currentReport.url}</td>
                </tr>

                <tr>
                  <td>Webapp OS</td>
                  <td>{this.state.currentReport.webapp_os}</td>
                </tr>
                {this.renderDetail()}
                {/* <tr>
                                    <td>
                                        Vuln#
                                    </td>
                                    <td>
                                        {this.state.currentReport.vuln}
                                    </td>
                                </tr> */}
                {/* <tr>
                                    <td>
                                        Is Scheduled
                                    </td>
                                    <td>
                                        {this.state.currentReport.webapp_is_scheduled === "true" ? 'Yes' : 'No'}
                                    </td>
                                </tr> */}
                <tr>
                  <td>Is Active</td>
                  <td>
                    {this.state.currentReport.is_active === true ? 'Yes' : 'No'}
                  </td>
                </tr>
                <tr>
                  <td>Created at</td>
                  <td>
                    {this.state.currentReport.created_at &&
                    this.state.currentReport.created_at.length > 0
                      ? moment(this.state.currentReport.created_at).format(
                          'lll',
                        )
                      : ''}
                  </td>
                </tr>
                <tr>
                  <td>Updated at</td>
                  <td>
                    {this.state.currentReport.updated_date &&
                    this.state.currentReport.updated_date.length > 0
                      ? moment(this.state.currentReport.updated_date).format(
                          'lll',
                        )
                      : ''}
                  </td>
                </tr>
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              size="sm"
              onClick={() => this.toggle.bind(this)()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {this.renderUnassign()}
        {this.renderLoader()}
        {this.renderCreateModal()}
      </>
    );
  }
}

export { Members };
